import {
    FormatTextdirectionLToRRounded,
    FormatTextdirectionRToLRounded,
} from '@mui/icons-material';
import BlockButton from './BlockButton';
import { useTranslation } from 'react-i18next';

function DirButtons() {
    const { t } = useTranslation();

    return (
        <div dir="ltr">
            <BlockButton
                path="attributes.dir"
                value="ltr"
                icon={<FormatTextdirectionLToRRounded fontSize="small" />}
                tooltip={t('Text Direction Left to Right')}
            />
            <BlockButton
                path="attributes.dir"
                value="rtl"
                icon={<FormatTextdirectionRToLRounded fontSize="small" />}
                tooltip={t('Text Direction Right to Left')}
            />
        </div>
    );
}

export default DirButtons;
